import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import { useNavigate } from 'react-router-dom';
import secureLocalStorage from 'react-secure-storage';
import { getCurrentUserRole } from 'modules/utilities/utility';
import { useApprovalsPageState } from 'modules/attendence_leave_tracker/store';
import { useToast } from "modules/navbar/top/store/toasterStore";
import { LEAVE_STATUS, userHouseConfig } from 'config';
import moment from 'moment';

const ApprovalPopUpForManager = () => {
  const navigate = useNavigate();
  const { setToaster } = useToast();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const { fetchApprovalFunc, approvalsData } = useApprovalsPageState();
  const userHouse = secureLocalStorage.getItem('house');
  const currentHour = moment().hour();

  useEffect(() => {
    if(currentHour >= 17 && currentHour < 19){
      fetchApprovalFunc(setToaster, { leaveStatus: LEAVE_STATUS.PENDING });
    }
  }, []);

  useEffect(()=>{
    if (currentHour === 18) {
      showModal(approvalsData?.totalCount);
    }
  },[approvalsData])

  const showModal = (count) => {
    const shown = secureLocalStorage.getItem('modalShown');
    if (shown !== 'true' && getCurrentUserRole() === 'admin' && count !== 0  && userHouseConfig.includes(userHouse)) {
      setTotalCount(count);
      setIsModalVisible(true);
    }
  };

  const handleOk = () => {
    setIsModalVisible(false);
    secureLocalStorage.setItem('modalShown', 'true');
    navigate('/approvals-tracker');
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    secureLocalStorage.setItem('modalShown', 'true');
  };

  return (
    <Modal title="Pending Approvals" open={isModalVisible} onOk={handleOk} onCancel={handleCancel}>
      <p>You have {totalCount} approvals pending in the approval tracker. Please approve them.</p>
    </Modal>
  );
};

export default ApprovalPopUpForManager;
